// src/hooks/useQuoteClose.js
// SEAM 9 VERIFIER: qclose-3e8a5c17-hook
//
// The live close record for ONE estimate:
//   organizations/{orgId}/quoteCloses/{quoteId}
// Written only by Cloud Functions (functions/utils/quoteClose.js) — the stage
// movers write it when an estimate closes or reopens, recordQuoteCloseDetails
// writes the operator's answers or a dismissal. Staff-read; portal customers
// cannot read it (firestore.rules qclose-3e8a5c17-rules), so this hook must
// never be used in a portal view.
//
// Returns { record, loaded }. record is null when the estimate has never been
// closed under Seam 9 (every estimate closed before 2026-09-30 has none — no
// backfill, by design).
import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

export default function useQuoteClose(orgId, quoteId) {
    const [state, setState] = useState({ record: null, loaded: false });

    useEffect(() => {
        if (!orgId || !quoteId) { setState({ record: null, loaded: false }); return undefined; }
        setState({ record: null, loaded: false });
        return onSnapshot(
            doc(db, `organizations/${orgId}/quoteCloses`, quoteId),
            (snap) => setState({ record: snap.exists() ? { id: snap.id, ...snap.data() } : null, loaded: true }),
            (err) => {
                console.warn('useQuoteClose: subscription failed', err);
                setState({ record: null, loaded: true });
            }
        );
    }, [orgId, quoteId]);

    return state;
}

// A record that still wants an answer: live (not reopened), nothing recorded,
// and nobody has dismissed the prompt. The ONE predicate the strip, the modal
// auto-open and the board all use, so they cannot disagree.
export function closeNeedsAnswer(record) {
    return !!record
        && !record.reopenedAt
        && !record.reason && !record.priceFeedback && !record.note
        && !record.nudgeDismissedAt;
}
